module.exports = __webpack_public_path__ + "img/category4.fe0bf6b2.jpg";